import request from '@/utils/request'

export function get() {
  return request({
    url: '/sys-config/get',
    method: 'get',
  })
}